const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
  },
  formRow: {
    display: 'flex',
    gap: '16px',
  },
  actions: {
    alignSelf: 'flex-end',
  },
};

export default styles;
